var D = Object.defineProperty;
var K = (o, e, n) => e in o ? D(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n;
var f = (o, e, n) => (K(o, typeof e != "symbol" ? e + "" : e, n), n);
import { ref as W, computed as _, openBlock as a, createElementBlock as p, normalizeClass as A, toDisplayString as S, createCommentVNode as b, onMounted as x, watch as X, pushScopeId as j, popScopeId as F, createElementVNode as u, defineAsyncComponent as M, resolveComponent as l, resolveDirective as H, withModifiers as J, withDirectives as Q, createVNode as g, Fragment as Y, Transition as O, withCtx as I, createBlock as L } from "vue";
import Z from "gsap";
var r;
(function(o) {
  o.meta = "meta", o.products = "products", o.shoppingcart = "shoppingcart", o.produktlisteFeatures = "produktlisteFeatures";
})(r || (r = {}));
const c = class c {
};
f(c, "state", W({
  meta: !1,
  products: !1,
  shoppingcart: !1,
  produktlisteFeatures: !1
})), f(c, "productNaviIsOpen", () => c.state.value.products), f(c, "metaNaviIsOpen", () => c.state.value.meta), f(c, "shoppingCartNaviIsOpen", () => c.state.value.shoppingcart), f(c, "TOGGLE_NAVI", (e) => {
  c.state.value[e] = !c.state.value[e], [r.produktlisteFeatures, r.products, r.shoppingcart, r.meta].filter((n) => n !== e).forEach((n) => c.state.value[n] = !1);
}), f(c, "CLOSE_NAVI", () => {
  [r.produktlisteFeatures, r.products, r.shoppingcart, r.meta].forEach((e) => c.state.value[e] = !1);
});
let i = c;
const q = {
  mounted: (o, e) => {
    o.clickOutsideEvent = (n) => {
      o === n.target || o.contains(n.target) || e.value();
    }, setTimeout(() => document.addEventListener("click", o.clickOutsideEvent), 1);
  },
  unmounted: (o) => {
    document.removeEventListener("click", o.clickOutsideEvent);
  }
}, R = {
  name: "ModuleNaviShoppingcartTrigger",
  props: {
    anz_wk_positionen: Number
  },
  setup(o) {
    return {
      shoppingcartOpen: _(() => i.shoppingCartNaviIsOpen()),
      toggleNaviShoppingcart: () => i.TOGGLE_NAVI(r.shoppingcart),
      shoppingcartClass: _(() => i.shoppingCartNaviIsOpen() ? "active" : "")
    };
  }
}, v = (o, e) => {
  const n = o.__vccOpts || o;
  for (const [t, d] of e)
    n[t] = d;
  return n;
}, oo = {
  key: 0,
  class: "km__button--shoppingcart--amount"
};
function eo(o, e, n, t, d, k) {
  return a(), p("button", {
    class: A(["km__button--icon shoppingcart", { active: t.shoppingcartOpen === !0 }]),
    onClick: e[0] || (e[0] = (...s) => t.toggleNaviShoppingcart && t.toggleNaviShoppingcart(...s)),
    "aria-label": "shoppingcart"
  }, [
    n.anz_wk_positionen !== 0 ? (a(), p("span", oo, S(n.anz_wk_positionen), 1)) : b("", !0)
  ], 2);
}
const P = /* @__PURE__ */ v(R, [["render", eo], ["__scopeId", "data-v-562b05ce"]]), no = {
  name: "ModuleNaviLogo"
}, to = { class: "km__header--logo" };
function io(o, e, n, t, d, k) {
  return a(), p("span", to, "owayo 3D-Konfigurator");
}
const ao = /* @__PURE__ */ v(no, [["render", io], ["__scopeId", "data-v-e69c21ea"]]), ro = {
  name: "NaviMetaTrigger",
  setup() {
    const o = Z.timeline({ paused: !0 });
    x(() => {
      o.to(".rect-mid", { duration: 0.4, scaleX: 0, ease: "power2.in" }, "step1"), o.to(".rect-top", { duration: 0.15, y: 25 }, "step2"), o.to(".rect-bottom", { duration: 0.15, y: -25 }, "step2"), o.to(".rect-top", { duration: 0.3, rotation: 45, transformOrigin: "50% 50%" }, "step3"), o.to(".rect-bottom", { duration: 0.3, rotation: -45, transformOrigin: "50% 50%" }, "step3");
    });
    const e = _(() => i.metaNaviIsOpen());
    X(() => e.value, (t) => t ? o.play() : o.reverse());
    function n() {
      i.TOGGLE_NAVI(r.meta);
    }
    return {
      metaOpen: e,
      toggleNaviMeta: n
    };
  }
}, so = (o) => (j("data-v-4b798f61"), o = o(), F(), o), co = /* @__PURE__ */ so(() => /* @__PURE__ */ u("svg", {
  viewBox: "0 0 100 80",
  width: "30",
  height: "40"
}, [
  /* @__PURE__ */ u("rect", {
    fill: "white",
    width: "100",
    height: "5",
    x: "0",
    y: "10",
    class: "rect-top"
  }),
  /* @__PURE__ */ u("rect", {
    fill: "white",
    width: "100",
    height: "5",
    x: "0",
    y: "35",
    class: "rect-mid"
  }),
  /* @__PURE__ */ u("rect", {
    fill: "white",
    width: "100",
    height: "5",
    x: "0",
    y: "60",
    class: "rect-bottom"
  })
], -1)), po = [
  co
];
function lo(o, e, n, t, d, k) {
  return a(), p("button", {
    class: A(["km__header__navi--meta--btn", { active: t.metaOpen === !0 }]),
    onClick: e[0] || (e[0] = (...s) => t.toggleNaviMeta && t.toggleNaviMeta(...s)),
    "aria-label": "services"
  }, po, 2);
}
const go = /* @__PURE__ */ v(ro, [["render", lo], ["__scopeId", "data-v-4b798f61"]]), uo = {
  name: "NaviProductCategoriesTrigger",
  setup() {
    const o = _(() => i.productNaviIsOpen());
    function e() {
      i.TOGGLE_NAVI(r.products);
    }
    return {
      productsOpen: o,
      toggleNaviProducts: e
    };
  }
};
function _o(o, e, n, t, d, k) {
  return a(), p("button", {
    class: A(["km__header__navi--product--btn", { active: t.productsOpen === !0 }]),
    onClick: e[0] || (e[0] = (...s) => t.toggleNaviProducts && t.toggleNaviProducts(...s)),
    "aria-label": "products"
  }, null, 2);
}
const mo = /* @__PURE__ */ v(uo, [["render", _o], ["__scopeId", "data-v-e56c61f2"]]);
var E;
(function(o) {
  o.musterservice = "musterservice", o.angebotsservice = "angebotsservice", o.designcheck = "designcheck", o.designwish = "designwish", o.productsize = "productsize", o.deliverytime = "deliverytime", o.contact = "contact", o.contactform = "contactform";
})(E || (E = {}));
var y;
(function(o) {
  o.produktListe = "produktListe";
})(y || (y = {}));
var h;
(function(o) {
  o.login = "login", o.logout = "logout", o.orders = "orders", o.account = "account", o.shoppingcart = "shoppingcart";
})(h || (h = {}));
const ho = {
  name: "ModuleNaviShoppingcart",
  components: {
    NaviCurrentShoppingcart: M(() => import("./NaviCurrentShoppingcart-Dd0uPpet.mjs"))
  },
  props: {
    username: String,
    shoppingcart: Array,
    loggedin: Boolean,
    shopName: String,
    language: String,
    land: String
  },
  setup(o, e) {
    return {
      logoutShoppingcart: () => {
        e.emit("open_component", h.logout);
      },
      showUserOrders: () => e.emit("open_component", h.orders),
      showUserAccount: () => e.emit("open_component", h.account),
      showLogin: () => e.emit("open_component", h.login),
      warenkorbFilled: _(() => o.shoppingcart.length > 0),
      openShoppingCart: () => {
        debugger;
        let n = window.location, t = location.protocol + "//" + location.hostname + "/shoppingcart?land=" + o.land.toLowerCase() + "&lang=" + o.language.toLowerCase();
        o.shopName !== "" && o.shopName !== null && o.shopName !== void 0 && (t = t + "&shop=" + o.shopName), document.cookie = "Shoppingcart_ReturnURL=" + n + ";path=/", window.location.href = t;
      },
      clickoutside: () => e.emit("close_shoppingcart_menu")
    };
  }
}, vo = { class: "km__navi--shoppingcart" }, ko = { class: "km__navi--close-wrapper" }, fo = { class: "km__navi--content-wrapper" }, No = { class: "km__navi__submenu__shoppingcart" }, Co = { class: "km__navi__heading_shoppingcart" }, wo = {
  key: 0,
  class: "km__list--modules shoppingcart--login"
}, bo = { class: "km__list__element" }, So = { class: "km__list__element" }, Oo = {
  key: 1,
  class: "km__shoppingcart--logout"
};
function Io(o, e, n, t, d, k) {
  const s = l("NaviCurrentShoppingcart"), C = H("click-outside");
  return a(), p("div", vo, [
    u("div", ko, [
      u("div", {
        class: "km__navi--close",
        onClick: e[0] || (e[0] = J((N) => o.$emit("close_shoppingcart_menu"), ["self"]))
      })
    ]),
    Q((a(), p("div", fo, [
      u("div", No, [
        u("h2", Co, S(o.$t("konf_Warenkorb_Vorschau")), 1),
        t.warenkorbFilled ? (a(), p("ul", wo, [
          u("li", bo, [
            g(s, {
              shoppingcart: n.shoppingcart,
              onOpenShoppingCart: t.openShoppingCart
            }, null, 8, ["shoppingcart", "onOpenShoppingCart"])
          ]),
          u("li", So, [
            u("button", {
              class: "km__button--standard checkout",
              onClick: e[1] || (e[1] = (...N) => t.openShoppingCart && t.openShoppingCart(...N))
            }, S(o.$t("konf_zurKasse")), 1)
          ])
        ])) : (a(), p("div", Oo, S(o.$t("konf_emptyWarenkorb")), 1))
      ])
    ])), [
      [C, () => t.clickoutside()]
    ])
  ]);
}
const $ = /* @__PURE__ */ v(ho, [["render", Io], ["__scopeId", "data-v-5a6affe1"]]), Lo = {
  name: "ModuleNaviAccountTrigger",
  props: {
    username: String,
    loggedin: Boolean
  },
  setup(o, e) {
    return {
      showLogin: () => e.emit("open_component", h.login),
      showUserAccount: () => e.emit("open_component", h.account)
    };
  }
};
function Mo(o, e, n, t, d, k) {
  return n.loggedin ? (a(), p("button", {
    key: 1,
    class: "km__button--icon account",
    onClick: e[1] || (e[1] = (...s) => t.showUserAccount && t.showUserAccount(...s)),
    "aria-label": "myaccount"
  })) : (a(), p("button", {
    key: 0,
    class: "km__button--icon account",
    onClick: e[0] || (e[0] = (...s) => t.showLogin && t.showLogin(...s)),
    "aria-label": "login"
  }));
}
const V = /* @__PURE__ */ v(Lo, [["render", Mo], ["__scopeId", "data-v-cdf86ff9"]]), Ao = {
  name: "NaviContainer",
  components: {
    ModuleNaviAccountTrigger: V,
    ModuleNaviShoppingcartTrigger: P,
    ModuleNaviLogo: ao,
    ModuleNaviMeta: M(() => import("./ModuleNaviMeta-Ddk9ggjv.mjs")),
    NaviMetaTrigger: go,
    NaviProductCategories: M(() => import("./NaviProductCategories-CjoGyd_5.mjs")),
    NaviProductCategoriesTrigger: mo,
    ModuleNaviShoppingcart: $
  },
  emits: ["open_component_request", "setProductList", "logout"],
  props: {
    username: String,
    shoppingcart: Array,
    loggedin: Boolean,
    auswahlprodukte_sortedinto_oberkategorien: Array,
    language: String,
    land: String
  },
  setup() {
    return {
      productsOpen: _(() => i.productNaviIsOpen()),
      naviMetaOpen: _(() => i.metaNaviIsOpen()),
      shoppingcartmenuOpen: _(() => i.shoppingCartNaviIsOpen()),
      close_productmenu: () => i.TOGGLE_NAVI(r.products),
      close_shoppingcart_menu: () => i.TOGGLE_NAVI(r.shoppingcart),
      close_metamenu: () => i.TOGGLE_NAVI(r.meta),
      close: () => i.CLOSE_NAVI()
    };
  }
}, To = { class: "km__header" };
function Eo(o, e, n, t, d, k) {
  var T;
  const s = l("NaviProductCategoriesTrigger"), C = l("NaviMetaTrigger"), N = l("ModuleNaviLogo"), w = l("ModuleNaviAccountTrigger"), G = l("ModuleNaviShoppingcartTrigger"), z = l("NaviProductCategories"), B = l("ModuleNaviMeta"), U = l("ModuleNaviShoppingcart");
  return a(), p(Y, null, [
    u("header", To, [
      g(s),
      g(C),
      g(N),
      g(w, {
        onOpen_component: e[0] || (e[0] = (m) => o.$emit("open_component_request", m)),
        username: n.username,
        loggedin: n.loggedin
      }, null, 8, ["username", "loggedin"]),
      g(G, {
        anz_wk_positionen: ((T = n.shoppingcart) == null ? void 0 : T.length) || 0
      }, null, 8, ["anz_wk_positionen"])
    ]),
    g(O, { name: "naviproductcategories" }, {
      default: I(() => [
        t.productsOpen ? (a(), L(z, {
          key: 0,
          onSetProductList: e[1] || (e[1] = (m) => o.$emit("setProductList", m)),
          auswahlprodukte_sortedinto_oberkategorien: n.auswahlprodukte_sortedinto_oberkategorien,
          onClose_menu: t.close_productmenu
        }, null, 8, ["auswahlprodukte_sortedinto_oberkategorien", "onClose_menu"])) : b("", !0)
      ]),
      _: 1
    }),
    g(O, { name: "navimeta" }, {
      default: I(() => [
        t.naviMetaOpen ? (a(), L(B, {
          key: 0,
          onOpenPopup: e[2] || (e[2] = (m) => o.$emit("open_component_request", m)),
          onClose_menu: t.close_metamenu
        }, null, 8, ["onClose_menu"])) : b("", !0)
      ]),
      _: 1
    }),
    g(O, { name: "navishoppingcart" }, {
      default: I(() => [
        t.shoppingcartmenuOpen ? (a(), L(U, {
          key: 0,
          onOpen_component: e[3] || (e[3] = (m) => o.$emit("open_component_request", m)),
          username: n.username,
          shoppingcart: n.shoppingcart,
          loggedin: n.loggedin,
          onLogout: e[4] || (e[4] = (m) => o.$emit("logout")),
          onClose_shoppingcart_menu: t.close_shoppingcart_menu,
          land: n.land,
          language: n.language
        }, null, 8, ["username", "shoppingcart", "loggedin", "onClose_shoppingcart_menu", "land", "language"])) : b("", !0)
      ]),
      _: 1
    })
  ], 64);
}
const yo = /* @__PURE__ */ v(Ao, [["render", Eo], ["__scopeId", "data-v-dd324f81"]]), Po = {
  name: "ShopMenue",
  components: {
    ModuleNaviShoppingcartTrigger: P,
    ModuleNaviShoppingcart: $,
    ModuleNaviAccountTrigger: V
  },
  emits: ["open_component_request"],
  props: {
    username: String,
    shoppingcart: Array,
    loggedin: Boolean,
    shopName: String,
    language: String,
    land: String,
    warenkorbPositionen: Number
  },
  setup() {
    return {
      close_shoppingcart_menu: () => i.CLOSE_NAVI(),
      shoppingcartmenuOpen: _(() => i.shoppingCartNaviIsOpen())
    };
  }
}, $o = { style: { display: "flex" } };
function Vo(o, e, n, t, d, k) {
  const s = l("ModuleNaviAccountTrigger"), C = l("ModuleNaviShoppingcartTrigger"), N = l("ModuleNaviShoppingcart");
  return a(), p("div", $o, [
    g(s, {
      onOpen_component: e[0] || (e[0] = (w) => o.$emit("open_component_request", w)),
      username: n.username,
      loggedin: n.loggedin
    }, null, 8, ["username", "loggedin"]),
    g(C, { anz_wk_positionen: n.warenkorbPositionen }, null, 8, ["anz_wk_positionen"]),
    g(O, { name: "navishoppingcart" }, {
      default: I(() => [
        t.shoppingcartmenuOpen ? (a(), L(N, {
          key: 0,
          onOpen_component: e[1] || (e[1] = (w) => o.$emit("open_component_request", w)),
          username: n.username,
          shoppingcart: n.shoppingcart,
          loggedin: n.loggedin,
          shopName: n.shopName,
          language: n.language,
          land: n.land,
          onClose_shoppingcart_menu: t.close_shoppingcart_menu
        }, null, 8, ["username", "shoppingcart", "loggedin", "shopName", "language", "land", "onClose_shoppingcart_menu"])) : b("", !0)
      ]),
      _: 1
    })
  ]);
}
const Go = /* @__PURE__ */ v(Po, [["render", Vo]]), Do = {
  install: (o, e) => {
    o.component("NaviContainer", yo), o.component("ShopMenue", Go), o.directive("click-outside", q);
  }
}, Ko = () => i.CLOSE_NAVI();
export {
  i as N,
  v as _,
  E as a,
  y as b,
  Ko as c,
  h as d,
  Do as i
};
